<div class="main">

  <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">


          <div class="card mb-3">
            <div class="card-body m-0">
              <div class="d-flex justify-content-center ">
                <a routerLink="/" class="logo d-flex align-items-center w-auto">
                  <img src="assets/img/medilinkLogo.svg" width="200px" alt="">
                </a>
              </div>
              <div class="pt-4 pb-2">
                <h5 class="card-title text-center pb-0 fs-4">Marketing MediLink</h5>
                <p class="text-center small">Ingresa tu usuario y contraseña para acceder</p>
              </div>
              <form [formGroup]="loginInput" (ngSubmit)="loginValidation()" class="row g-3 ">
                <div class="col-12">
                  <label for="yourUsername" class="form-label">Username</label>
                  <div class="input-group has-validation">
                    <span class="input-group-text" id="inputGroupPrepend"><i class="bi bi-person"></i></span>
                    <input formControlName="username" type="text" name="username" class="form-control" id="yourUsername" autocomplete="current-username" required>
                    <div class="invalid-feedback">Por favor ingresa tu username!.</div>
                  </div>
                </div>
                <div class="col-12">
                  <label for="yourPassword" class="form-label">Contraseña</label>
                  <div class="input-group has-validation">
                    <span class="input-group-text" id=""><i class="bi bi-key"></i></span>
                    <input formControlName="password"  type="password" name="password" class="form-control" id="yourPassword" autocomplete="current-password">
                    <div class="invalid-feedback">!Por favor ingresa tu contraseña!</div>
                  </div>
                </div>
                <div class="col-12">
                  <button class="btn btn-primary w-100"  type="submit">Ingresar</button>
                </div>
              </form>

            </div>
          </div>



        </div>
      </div>
    </div>

  </section>

</div>


<app-notifications/>
